module.exports = __webpack_public_path__ + "static/media/WW2-USA.b579b1a3.jpg";